import * as types from './updateSystemActionTypes';

const initialState = {
    lastDataUpdateDate: 0,
    lastProductUpdateDate: 0
};

const changeDate = (state, action) => {
    const { date } = action;
    return {
        ...state, 
        lastDataUpdateDate: date
    };
}

const changeProductDate = (state, action) => {
  const { date } = action;
  return {
      ...state, 
      lastProductUpdateDate: date
  };
}

export const updateSystem = (state = initialState, action) => {
    switch(action.type) {
        case types.CHANGE_DATE:         return changeDate(state, action);
        case types.CHANGE_PRODUCT_DATE: return changeProductDate(state, action);
        case types.ALREADY_INIT:        return state;   
        default:                        return state;
    }
}

export default updateSystem;


// WEBPACK FOOTER //
// ./src/components/UpdateSystem/updateSystemReducers.js